export default {
    '1_month_ago': "1 ай мурун",
    '12_months_ago': "12 ай мурун",
    '3_months_ago': "3 ай мурун",
    '6_months_ago': "6 ай мурун",
    above_1_month: "1 айдан жогору",
    above_1_year: "1 жылдан жогору",
    above_2_months: "2 айдан жогору",
    above_3_months: "3 айдан жогору",
    above_6_months: "6 айдан жогору",
    add_patients: "Бейтаптарды кошуу",
    add_standard: "Стандарттыктарды кошуу",
    after_one_day: "Бир күндөн кийин",
    after_service: "Кызматты алгандан кийин",
    agreement_to_get_notifications_in_max: "Максдагы эскертмелерди алуу үчүн макулдук",
    all_statuses: "Бардык статустар",
    amount_of_patients: "Бейтаптардын саны",
    april: "Апрель",
    are_you_sure_you_want_to_delete_mailing: "Сиз чын эле жөнөтмөнү алып салгыңыз келеби?",
    august: "Август",
    birth_day: "Туулган күн",
    birth_month: "Туулган ай",
    cannot_be_delivered: "Жеткирүү мүмкүн эмес",
    channel: "Канал",
    channels: "Каналдар",
    complex_status_changed: "Дарылоо планында комплекстүү статустун өзгөртүү",
    create_mailing: "Жөнөтмөнү түзүү",
    december: "Декабрь",
    do_not_send_at_night_time: "Түнкү убакта жөнөтүлбөйт (22:00 - 07:00)",
    does_not_contain: "Камтыбайт",
    duplicate: "Көчүрүү",
    february: "Февраль",
    given_time: "Берилген убакыт",
    has_future_visit: "Келерки даталарга визит бар",
    has_tags: "Белгилери бар",
    has_treatment_plan_with_status: "Статусу бар дарылоо планы бар",
    has_visit_with_status: "Статусу бар визити бар",
    immediately_after_creating: "Түзгөндөн кийин",
    january: "Январь",
    july: "Июль",
    june: "Июнь",
    laboratory_order_status: "Жумуш тартиби абалы",
    laboratory_order_status_changed: "Заказдын статусун өзгөртүү",
    launch_mailing: "Жөнөтмөнү иштетүү",
    mailing: "Жөнөтмө",
    mailing_date: "Жөнөтмөнүн датасы",
    mailing_report: "Жөнөтмөлөр боюнча отчет",
    mailings: "Жөнөтмөлөр",
    march: "Март",
    marketing: "Маркетинг",
    marketing_mailing: "Жөнөтмө",
    may: "Май",
    no_push_token: "Токен жок",
    not_enough_balance: "Эсепте каражат жетишсиз",
    november: "Ноябрь",
    october: "Октябрь",
    of_days: "күн",
    of_hours: "саат",
    passed_since_last_visit: "Акыркы визиттен бери  өттү",
    payments_were: "Төлөндү",
    plan_status_changed: "Дарылоо планынын статусу өзгөрдү",
    push_notification: "Push-билдирме",
    push_notifications: "Push-билдирмелер",
    ready: "Даяр",
    retry: "Дагы бир жолу аракет кылуу",
    same_day: "Ошол эле күнү",
    save_filter: "Фильтрди сактоо",
    send_again: "Кайра жөнөтүү",
    send_date: "Жөнөтмөнүн датасы",
    send_info: "Жеткирүү жөнүндө маалымат",
    sent_slash_error: "Жөнөтүлдү / Ката",
    september: "Сентябрь",
    since_last_visit: "Акыркы визиттен кийин",
    sms_message: "СМС-билдирме",
    stop_mailing: "Жөнөтмөнү токтотуу",
    tags_for_marketing_mailing: "Маалыматты автоматтык түрдө көрсөтүү үчүн тэгдер:",
    task_title: "Тапшырма ат",
    time: "Убакыт",
    token: "Токен",
    tokens: "Токендер",
    too_many_attempts: "Өтө көп жөнөтүү аракети",
    total_in_group: "Топто бардыгы",
    treatment_plan_created: "Жаңы дарылоо планы түзүлдү",
    users_selected: "Тандалган колдонуучулар",
    visit_time_changed: "Визиттин убактысы жылдырылды",
    wrong_credentials: "Жөнөтүү кызматынын туура эмес авторизациялык маалыматтары",
    wrong_phone_number: "Туура эмес телефон номери"
}
